// 资产里支持NFT的链
export const NFT_SUPPORT_CHAIN: string[] = [
  'ETH',
  'BSC',
  'MATIC',
  'ARBI',
  'CAVAX',
  'OP',
  'SOL',
];
// NFT 图片mime 类型
export const NFT_IMG_TYPES =
  'image/png,image/jpeg,image/gif,image/svg+xml,image/webp,image/svg'.split(
    ','
  );
// Video 类型
export const NFT_VIDEO_TYPES = 'video/mp4'.split(',');
// 音乐类型
export const NFT_AUDIO_TYPES = 'audio/mpeg,audio/wav'.split(',');
export enum NFTContractType {
  'ERC-721' = 1,
  'ERC-1155' = 2,
  other = 3,
}

export const SOL_CHAIN_ID = 999999997;

export function removeTrailingZeros(numStr: string): string {
  return numStr.replace(/(\.[0-9]*[1-9])0*|(\.0*)$/, '$1');
}
